import api from '../../services/api';
import type { PerfilData, PerfilDataDTO } from '../../shared/interfaces/perfil';
import type { ScreenData } from '../../shared/interfaces/screen';

const PopulateFaqScreens = async (
  faqDTOs: PerfilDataDTO[],
): Promise<PerfilData[]> => {
  const responseScreen = await api.get(`/tela`);

  let faqs: PerfilData[] = [];
  for (let index = 0; index < faqDTOs.length; index++) {
    const faqDTO = faqDTOs[index];

    let faq: PerfilData = {
      id: faqDTO.id,
      nomePerfil: faqDTO.nomePerfil,
    };

    faq.idTelasList = responseScreen.data.filter(
      (s: ScreenData) =>
        faqDTO && faqDTO.idTelasList && faqDTO.idTelasList.includes(s.id),
    );

    faqs.push(faq);
  }

  return faqs;
};

export default PopulateFaqScreens;
